export default "__VITE_ASSET__DvBcAmSZ__"